import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const InstituteWiseMaterialTypeList = Loadable(
  lazy(() => import("features/instituteWiseMaterialType/components/List"))
);
const InstituteWiseMaterialTypePage = Loadable(
  lazy(() => import("features/instituteWiseMaterialType/components/Page"))
);


const routes = {
  path: "instituteWiseMaterialType",
  children: [
    { path: "", element: <InstituteWiseMaterialTypeList /> },
    { path: "add", element: <InstituteWiseMaterialTypePage /> },
    {
      path: "edit/:instituteWiseMaterialTypeId?",
      element: <InstituteWiseMaterialTypePage />,
    },
  ],
};

export default routes;
